(function () {
  async function initRepeat2() {
    var root = document.querySelector('[data-repeat2-root]');
    if (!root) return;

    var variantsNode = root.querySelector('[data-repeat2-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { console.error(error); }

    function sizeCopy(size, unit) {
      var match = String(size || '').match(/(\d+(?:\.\d+)?)\s*×\s*(\d+(?:\.\d+)?)\s*cm/i);
      if (!match) return { dimensions: size, area: '' };
      var widthCm = Number(match[1]);
      var heightCm = Number(match[2]);
      var areaSquareMetres = (widthCm * heightCm) / 10000;
      if (unit === 'in') {
        return {
          dimensions: Math.round(widthCm / 2.54) + ' × ' + Math.round(heightCm / 2.54) + ' inch',
          area: (areaSquareMetres * 10.7639).toFixed(2) + ' ft²'
        };
      }
      return {
        dimensions: size,
        area: areaSquareMetres.toFixed(2) + ' m²'
      };
    }

    function appendUnitCopy(parent, unit, copy, hidden) {
      var span = document.createElement('span');
      span.setAttribute('data-repeat2-unit-copy', unit);
      span.textContent = copy;
      span.hidden = hidden;
      parent.appendChild(span);
    }

    function rebuildSizeButtons(productData) {
      var grid = root.querySelector('.repeat2-size-grid');
      if (!grid) return;
      var sizeOption = (productData.options || []).find(function (option) { return option.name === 'Size'; });
      var fixedSizes = sizeOption ? sizeOption.values.filter(function (size) { return size !== 'Custom your size'; }) : [];
      if (!fixedSizes.length) return;

      grid.textContent = '';
      fixedSizes.forEach(function (size, index) {
        var cmCopy = sizeCopy(size, 'cm');
        var inCopy = sizeCopy(size, 'in');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'repeat2-size-card' + (index === 0 ? ' is-selected' : '');
        button.setAttribute('data-repeat2-size', size);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');

        var strong = document.createElement('strong');
        appendUnitCopy(strong, 'cm', cmCopy.dimensions, false);
        appendUnitCopy(strong, 'in', inCopy.dimensions, true);
        button.appendChild(strong);

        var area = document.createElement('span');
        appendUnitCopy(area, 'cm', cmCopy.area, false);
        appendUnitCopy(area, 'in', inCopy.area, true);
        button.appendChild(area);
        grid.appendChild(button);
      });
    }

    try {
      var productResponse = await fetch(window.location.pathname + '.js?repeat2=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (productResponse.ok) {
        var productData = await productResponse.json();
        variants = (productData.variants || []).map(function (variant) {
          return {
            id: String(variant.id),
            size: variant.option1,
            material: variant.option2,
            price: Number(variant.price),
            sku: variant.sku || '',
            available: Boolean(variant.available)
          };
        });
        rebuildSizeButtons(productData);
      }
    } catch (error) {
      console.warn('Repeat 2 product refresh failed; using embedded product data.', error);
    }

    var form = root.querySelector('.repeat2-fixed-form');
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-repeat2-size]'));
    var materialButtons = Array.prototype.slice.call(root.querySelectorAll('[data-repeat2-material]'));
    var unitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-repeat2-unit]'));
    var variantInput = root.querySelector('[data-repeat2-variant-id]');
    var price = root.querySelector('[data-repeat2-price]');
    var buttonPrice = root.querySelector('[data-repeat2-button-price]');
    var addButton = root.querySelector('[data-repeat2-add]');
    var sku = root.querySelector('[data-repeat2-sku]');
    var quantity = root.querySelector('[data-repeat2-fixed-quantity]');
    var quantityDisplay = root.querySelector('[data-repeat2-quantity-value]');
    var customPanel = root.querySelector('.repeat2-custom-panel');
    var selectedSize = sizeButtons.length ? sizeButtons[0].getAttribute('data-repeat2-size') : '';
    var selectedMaterial = materialButtons.length ? materialButtons[0].getAttribute('data-repeat2-material') : '';
    var selectedUnit = 'cm';
    var currency = root.getAttribute('data-currency-symbol') || '£';
    var cropImage = root.querySelector('#crop_image_main');
    var cropSource = root.getAttribute('data-repeat2-crop-src');
    if (cropImage && cropSource) cropImage.src = cropSource;

    function money(cents) {
      return currency + (Number(cents || 0) / 100).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function fixedQuantity() {
      var value = parseInt(quantity.value, 10);
      return Number.isFinite(value) && value >= 1 ? value : 1;
    }

    function commitFixedQuantity() {
      quantity.value = String(fixedQuantity());
      if (quantityDisplay) quantityDisplay.textContent = quantity.value;
      updateFixedSelection();
    }

    function fixedVariants() {
      return variants.filter(function (variant) { return variant.size !== 'Custom your size'; });
    }

    function variantsForSize(size) {
      return fixedVariants().filter(function (variant) {
        return variant.size === size && variant.available;
      });
    }

    function findVariant(size, material) {
      return fixedVariants().find(function (variant) {
        return variant.size === size && variant.material === material;
      });
    }

    function findUnitPriceVariant(material) {
      return variants.find(function (variant) {
        return variant.size === 'Custom your size' && variant.material === material;
      });
    }

    function setPressed(buttons, attribute, selected) {
      buttons.forEach(function (button) {
        var active = button.getAttribute(attribute) === selected;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateMaterialPrices() {
      materialButtons.forEach(function (button) {
        var material = button.getAttribute('data-repeat2-material');
        var unitPriceVariant = findUnitPriceVariant(material);
        var copy = button.querySelector('[data-repeat2-material-price]');
        if (copy && unitPriceVariant) {
          var unitPrice = selectedUnit === 'in' ? Number(unitPriceVariant.price) / 10.7639 : unitPriceVariant.price;
          copy.textContent = money(unitPrice) + (selectedUnit === 'in' ? ' / ft²' : ' / m²');
        }
      });
    }

    function updateMaterialAvailability() {
      materialButtons.forEach(function (button) {
        var material = button.getAttribute('data-repeat2-material');
        var variant = findVariant(selectedSize, material);
        var available = Boolean(variant && variant.available);
        button.disabled = !available;
        button.hidden = !available;
      });
    }

    function updateVisibleSizes() {
      sizeButtons.forEach(function (button) {
        var size = button.getAttribute('data-repeat2-size');
        button.hidden = variantsForSize(size).length === 0;
      });
    }

    function updateUnit() {
      setPressed(unitButtons, 'data-repeat2-unit', selectedUnit);
      root.querySelectorAll('[data-repeat2-unit-copy]').forEach(function (copy) {
        copy.hidden = copy.getAttribute('data-repeat2-unit-copy') !== selectedUnit;
      });
      updateMaterialPrices();
    }

    function updateFixedSelection() {
      var variant = findVariant(selectedSize, selectedMaterial);
      if (!variant || !variant.available) {
        var fallback = variantsForSize(selectedSize)[0];
        if (fallback) {
          selectedMaterial = fallback.material;
          variant = fallback;
        }
      }

      updateVisibleSizes();
      setPressed(sizeButtons, 'data-repeat2-size', selectedSize);
      setPressed(materialButtons, 'data-repeat2-material', selectedMaterial);
      updateMaterialPrices();
      updateMaterialAvailability();
      if (!variant) return;

      variantInput.value = variant.id;
      price.textContent = money(variant.price);
      buttonPrice.textContent = money(variant.price * fixedQuantity());
      sku.textContent = variant.sku || '';
      addButton.disabled = !variant.available;
      addButton.classList.toggle('is-disabled', !variant.available);
    }

    function openCustom() {
      customPanel.setAttribute('aria-hidden', 'false');
      var widthInput = root.querySelector('.cm_width');
      var attempts = 0;
      function openWhenReady() {
        if (!previewButton) return;
        if (previewButton.disabled && attempts < 40) {
          attempts += 1;
          window.setTimeout(openWhenReady, 100);
          return;
        }
        previewButton.click();
        window.setTimeout(function () {
          if (widthInput) widthInput.focus({ preventScroll: true });
        }, 120);
      }
      openWhenReady();
    }

    function closeCustom() {
      root.classList.remove('is-custom-dialog-open');
      document.body.classList.remove('repeat2-custom-open');
      customPanel.setAttribute('aria-hidden', 'true');
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectedSize = button.getAttribute('data-repeat2-size');
        updateFixedSelection();
      });
    });

    materialButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selectedMaterial = button.getAttribute('data-repeat2-material');
        updateFixedSelection();
      });
    });

    unitButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectedUnit = button.getAttribute('data-repeat2-unit');
        updateUnit();
      });
    });

    root.querySelectorAll('[data-repeat2-custom-open]').forEach(function (button) {
      button.addEventListener('click', openCustom);
    });
    root.querySelectorAll('[data-repeat2-custom-close]').forEach(function (button) {
      button.addEventListener('click', closeCustom);
    });

    var previewButton = root.querySelector('[data-open-crop]');
    if (previewButton) {
      previewButton.addEventListener('click', function () {
        root.classList.remove('is-custom-dialog-open');
        document.body.classList.remove('repeat2-custom-open');
        customPanel.setAttribute('aria-hidden', 'false');
      });
    }

    root.querySelector('[data-repeat2-quantity-minus]').addEventListener('click', function () {
      quantity.value = Math.max(1, fixedQuantity() - 1);
      commitFixedQuantity();
    });
    root.querySelector('[data-repeat2-quantity-plus]').addEventListener('click', function () {
      quantity.value = fixedQuantity() + 1;
      commitFixedQuantity();
    });

    form.addEventListener('submit', function (event) {
      quantity.value = String(fixedQuantity());
      if (!variantInput.value || addButton.disabled) event.preventDefault();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-custom-dialog-open') && !root.classList.contains('is-crop-workspace')) closeCustom();
    });

    if (fixedQuantity() < 1 || !quantity.value) quantity.value = '1';
    commitFixedQuantity();
    updateUnit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRepeat2);
  else initRepeat2();
})();
